<template>
  <div class="featured-dorms__list dorm-card__list user__list-wrp">
    <container>
      <div class="user__list-offer">
        <!--//components-->
        <comments/>
        <!--//components-->
      </div>
    </container>
  </div>
</template>

<script>
import Comments from '@/components/Comments'

export default {
  name: 'UserComment',
  components: {
    Comments
  }
}
</script>

<style lang="scss">
.user__list-comment{
  margin-top: 15px;
}
</style>
